/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMfaCredentials200ResponseCredentialsInner
 */
export interface GetMfaCredentials200ResponseCredentialsInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    label?: string | null;
    /**
     * 
     */
    createdDate?: number | null;
    /**
     * 
     */
    removable?: boolean;
}

/**
 * Check if a given object implements the GetMfaCredentials200ResponseCredentialsInner interface.
 */
export function instanceOfGetMfaCredentials200ResponseCredentialsInner(value: object): value is GetMfaCredentials200ResponseCredentialsInner {
    return true;
}

export function GetMfaCredentials200ResponseCredentialsInnerFromJSON(json: any): GetMfaCredentials200ResponseCredentialsInner {
    return GetMfaCredentials200ResponseCredentialsInnerFromJSONTyped(json, false);
}

export function GetMfaCredentials200ResponseCredentialsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMfaCredentials200ResponseCredentialsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'label': json['label'] === undefined ? undefined : json['label'] === null ? null : json['label'],
        'createdDate': json['createdDate'] === undefined ? undefined : json['createdDate'] === null ? null : json['createdDate'],
        'removable': json['removable'] == null ? undefined : json['removable'],
    };
}

export function GetMfaCredentials200ResponseCredentialsInnerToJSON(json: any): GetMfaCredentials200ResponseCredentialsInner {
    return GetMfaCredentials200ResponseCredentialsInnerToJSONTyped(json, false);
}

export function GetMfaCredentials200ResponseCredentialsInnerToJSONTyped(value?: GetMfaCredentials200ResponseCredentialsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'label': value['label'],
        'createdDate': value['createdDate'],
        'removable': value['removable'],
    };
}

